import { DocumentUpload, RuggedTrashCan } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  appearance: none;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledDeleteIcon = styled(RuggedTrashCan)`
  width: auto;
  height: ${rem('24px')};

  path {
    fill: ${({ theme }) => theme.colors.cross.red};
  }
`;

export const StyledDocumentUploadIcon = styled(DocumentUpload)`
  width: auto;
  height: ${rem('28px')};

  path {
    transition: all 0.2s;
    fill: ${({ theme }) => theme.colors.cross.deepBlu};
  }
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: ${rem('56px')};
  border-radius: ${rem('8px')};
  padding: ${rem('12px')} ${rem('16px')};
  position: relative;
`;

export const StyledInput = styled.input`
  position: absolute;
  width: 0;
  height: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
`;

export const StyledNav = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  z-index: 2;
`;

export const StyledTitle = styled.h5<{ noFile: boolean }>`
  margin: 0;
  color: ${({ theme, noFile }) =>
    noFile ? theme.colors.cross.grayson : theme.colors.cross.deepBlu};
  font-size: ${rem('16px')};
  font-weight: 400;
  position: relative;
  z-index: 2;
  text-align: left;
`;

export const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 0 ${rem('8px')} 0;
  border: ${rem('1px')} dashed ${({ theme }) => theme.colors.cross.grayson};
  border-radius: ${rem('8px')};
  transition: all 0.2s;
  overflow: hidden;
  background-color: 'transparent';
`;
